/**
 * Shared TypeScript types for checklists
 */
/**
 * Check if a checklist type requires an outcome selection
 * @param type - The checklist type
 * @returns True if the type requires an outcome
 */
export function requiresOutcome(type) {
    return type === 'ROB2' || type === 'ROBINS_I';
}
//# sourceMappingURL=types.js.map